import { type Action, combineReducers } from "@reduxjs/toolkit";
import countryReducer from "../country/slice";
import customerInfoReducer from "../customerInfo/slice";
import quickOrderReducer from "../quickOrder/slice";
import draftOrderReducer from "../draftOrder/slice";
import orderHistoryReducer from "../orderhistory/slice";
import imageDetailsReducer from "../orderhistoryimage/slice";
import labelCatalogReducer from "../labelCatalog/slice";
import loaderReducer from "../loader/slice";
import notificationReducer from "../notifications/slice";
import userReducer from "../user/slice";
import shipmentReducer from "../shipmentTracking/slice";
import snackbarReducer from "../snackbar/slice";
import invoiceReducer from "../invoice/slice";
import imageAnalysisReducer from "../imageAnalyze/slice";
import uploadFileReducer from "../uploadFile/slice";
import guestUploadFileReducer from "../guestOrderUploadFile/slice";
import configurationReducer from "../configuration/slice";
import guestOrderReducer from "../guestOrder/slice";
import photoUploadReducer from "../photoUpload/slice";
import photoUploadFileReducer from "../photoUploadUploadFile/slice";

const appReducer = combineReducers({
  loader: loaderReducer,
  country: countryReducer,
  customerInfo: customerInfoReducer,
  quickOrder: quickOrderReducer,
  draftOrderList: draftOrderReducer,
  orderDetailsList: orderHistoryReducer,
  labelCatalog: labelCatalogReducer,
  notificationDetails: notificationReducer,
  transportKeyDetails: userReducer,
  imageDetails: imageDetailsReducer,
  shipment: shipmentReducer,
  snackbar: snackbarReducer,
  invoice: invoiceReducer,
  imageAnalysis: imageAnalysisReducer,
  uploadFiles: uploadFileReducer,
  configuration: configurationReducer,
  guestOrder:guestOrderReducer,
  guestUploadFiles : guestUploadFileReducer,
  photoUpload: photoUploadReducer,
  photoUploadFiles : photoUploadFileReducer
});

const rootReducer = (
  state: any,
  action: Action
): ReturnType<typeof appReducer> => {
  return appReducer(state, action);
};

export default rootReducer;
